<template>
  <div>
    <Header></Header>
    <div>
      <img class="lbt" :src="baseURL+solution.mainDrawingSrc" alt="" />
    </div>
    <div class="body">
      <div>
        <div class="cpszh">{{solution.title}}分类</div>
        <div class="bodyTitle">
          <div class="product">{{solution.eTitle}}</div>
<!--          <div class="more">-->
<!--            <div class="gdal">更多服务</div>-->
<!--            <div>></div>-->
<!--          </div>-->
        </div>
      </div>
      <div class="bodyTopContent">
        <div class="jjfaFirZ1" v-if="classList.length>0">
          <div class="jjfaFirZ1M"></div>
          <img class="jjfaz1" :src="baseURL+classList[0].fileSrc" alt="" />
          <div class="jjfaFirZ1Font1">{{classList[0].title}}</div>
          <div class="jjfaFirZ1Font2">
            {{classList[0].introduce}}
          </div>
          <!-- <div class="jjfaFirZ1Font3">了解更多</div> -->
        </div>
        <div class="jjfaFirZ2" v-if="classList.length>1">
          <div class="jjfaFirZ2M"></div>
          <img class="jjfaz2" :src="baseURL+classList[1].fileSrc" alt="" />
          <div class="jjfaFirZ2Font1">{{classList[1].title}}</div>
          <div class="jjfaFirZ2Font2">
            {{classList[1].introduce}}
          </div>
          <!-- <div class="jjfaFirZ2Font3">了解更多</div> -->
        </div>
      </div>
      <div class="bodyCenterContent">
        <div class="jjfaFirZ3" v-if="classList.length>2">
          <div class="jjfaFirZ3M"></div>
          <img class="jjfaz3" :src="baseURL+classList[2].fileSrc" alt="" />
          <div class="jjfaFirZ3Font1">{{classList[2].title}}</div>
          <div class="jjfaFirZ3Font2">
            {{classList[2].introduce}}
          </div>
          <!-- <div class="jjfaFirZ3Font3">了解更多</div> -->
        </div>
        <div class="jjfaFirZ4" v-if="classList.length>3">
          <div class="jjfaFirZ4M"></div>
          <img class="jjfaz4" :src="baseURL+classList[3].fileSrc" alt="" />
          <div class="jjfaFirZ4Font1">{{classList[3].title}}</div>
          <div class="jjfaFirZ4Font2">
            {{classList[3].introduce}}
          </div>
          <!-- <div class="jjfaFirZ4Font3">了解更多</div> -->
        </div>
      </div>
      <div class="bodyBottomContent">
        <div class="jjfaFirZ5" v-if="classList.length>4">
          <div class="jjfaFirZ5M"></div>
          <img class="jjfaz5" :src="baseURL+classList[4].fileSrc" alt="" />
          <div class="jjfaFirZ5Font1">{{classList[4].title}}</div>
          <div class="jjfaFirZ5Font2">
            {{classList[4].introduce}}
          </div>
          <!-- <div class="jjfaFirZ5Font3">了解更多</div> -->
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/views/header.vue";
import Footer from "@/views/footer.vue";
import {getSolution,getSolutionClassificationPage} from "@/api/open";
export default {
  components: {
    Header,
    Footer,
  },
  watch: {
    '$route' (to, from) { //监听URL地址栏参数变化
      if (this.$route.query.solutionId) {
        this.solutionId = this.$route.query.solutionId
        this.getById()
        this.getClassList()
      }
    }
  },
  data() {
    return {
      solutionId:null,
      solution:{},
      classList:[],
      baseURL: process.env.VUE_APP_BASE_API,
    };
  },
  created() {
    this.solutionId = this.$route.query.solutionId
    this.getById()
    this.getClassList()
  },
  methods: {
    getById(){
      getSolution({id:this.solutionId}).then(res=>{
        this.solution = res.data
      })
    },
    getClassList(){
      getSolutionClassificationPage({solutionId:this.solutionId}).then(res=>{
        this.classList = res.rows
      })
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.lbt {
  width: 100%;
}
.body {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 80px;
  background: #fff !important;
}
.cpszh {
  font-size: 24px;
  padding: 40px 0 4px 32px;
  color: #183f85;
  letter-spacing: 1px;
}
.bodyTitle {
  display: flex;
  justify-content: space-between;
  margin-right: 32px;
}
.product {
  font-size: 24px;
  color: #bfbfbf;
  margin-left: 32px;
  letter-spacing: 1px;
}
.more {
  display: flex;
}
.gdal {
  margin-right: 4px;
  font-size: 14px;
  color: #7d7d7d;
}
.bodyTopContent {
  margin-top: 24px;
  display: flex;
}
.jjfaz1 {
  width: 350px;
  height: 500px;
  margin: 0 24px 24px 32px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.jjfaz2 {
  width: 762px;
  height: 500px;
  margin: 0 0 24px 0;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.bodyCenterContent {
  display: flex;
}
.jjfaz3 {
  width: 762px;
  height: 500px;
  margin: 0 24px 24px 32px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.jjfaz4 {
  width: 350px;
  height: 500px;
  margin: 0 0 24px 0;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.jjfaz5 {
  width: 1138px;
  height: 296px;
  margin: 0 0 0 32px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.jjfaFirZ1 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirZ1:hover{
  transform: scale(1.05);
}
.jjfaFirZ1Font1 {
  position: absolute;
  top: 24px;
  left: 56px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirZ1Font2 {
  position: absolute;
  bottom: 56px;
  left: 56px;
  width: 309px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirZ1Font3 {
  position: absolute;
  bottom: 40px;
  right: 40px;
  color: #ffffff;
  line-height: 17px;
  z-index: 2;
  cursor: pointer;
}
.jjfaFirZ2 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirZ2:hover{
  transform: scale(1.05);
}
.jjfaFirZ2Font1 {
  position: absolute;
  top: 24px;
  left: 24px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirZ2Font2 {
  position: absolute;
  bottom: 56px;
  left: 24px;
  width: 706px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirZ2Font3 {
  position: absolute;
  bottom: 40px;
  right: 16px;
  color: #ffffff;
  line-height: 17px;
    z-index: 2;
  cursor: pointer;
}
.jjfaFirZ3 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirZ3:hover{
  transform: scale(1.05);
}
.jjfaFirZ3Font1 {
  position: absolute;
  top: 24px;
  left: 56px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
    z-index: 2;
}
.jjfaFirZ3Font2 {
  position: absolute;
  bottom: 56px;
  left: 56px;
  width: 706px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
    z-index: 2;
}
.jjfaFirZ3Font3 {
  position: absolute;
  bottom: 40px;
  right: 40px;
  color: #ffffff;
  line-height: 17px;
    z-index: 2;
  cursor: pointer;
}
.jjfaFirZ4 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirZ4:hover{
  transform: scale(1.05);
}
.jjfaFirZ4Font1 {
  position: absolute;
  top: 24px;
  left: 24px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
    z-index: 2;
}
.jjfaFirZ4Font2 {
  position: absolute;
  bottom: 56px;
  left: 24px;
  width: 309px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
    z-index: 2;
}
.jjfaFirZ4Font3 {
  position: absolute;
  bottom: 40px;
  right: 16px;
  color: #ffffff;
  line-height: 17px;
    z-index: 2;
  cursor: pointer;
}
.jjfaFirZ5 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirZ5:hover{
  transform: scale(1.05);
}
.jjfaFirZ5Font1 {
  position: absolute;
  top: 24px;
  left: 56px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
    z-index: 2;
}
.jjfaFirZ5Font2 {
  position: absolute;
  bottom: 32px;
  left: 56px;
  width: 706px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
    z-index: 2;
}
.jjfaFirZ5Font3 {
  position: absolute;
  bottom: 16px;
  right: 48px;
  color: #ffffff;
  line-height: 17px;
    z-index: 2;
  cursor: pointer;
}
.jjfaFirZ1M {
  width: 350px;
  height: 500px;
  margin: 0 24px 24px 32px;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  position: relative;
  z-index: 1;
}
.jjfaFirZ2M {
  width: 762px;
  height: 500px;
  margin: 0 0 24px 0;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  position: relative;
  z-index: 1;
}
.jjfaFirZ3M {
  width: 762px;
  height: 500px;
  margin: 0 24px 24px 32px;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  position: relative;
  z-index: 1;
}
.jjfaFirZ4M {
  width: 350px;
  height: 500px;
  margin: 0 0 24px 0;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  position: relative;
  z-index: 1;
}
.jjfaFirZ5M {
  width: 1138px;
  height: 296px;
  margin: 0 0 0 32px;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  position: relative;
  z-index: 1;
}
</style>
